module.exports = __webpack_public_path__ + "img/secret_three.85c1e8f4.png";